module.exports = __webpack_public_path__ + "static/assets/8c0cfcd49f1a8377e1826b66bdd1c1c2.svg";